import * as React from "react";
import { GifLoader } from "../gif-loader/GifLoader";
import { Button } from "./DbotButtonStyles";
import { replaceStringVariables } from "../../business/ResolveConversationFunctions";
import { DbotCheckboxButton } from "./DbotCheckboxButton";
import { getContentLanguage } from "static-content/view/api";

export const DbotButtonPresenter = (button, onclick, onClickImage, appMode, variables, sequence, tag, totalButtons) => {
  const onClickF = () => {
    if (tag === 'likert') {
      const lang = getContentLanguage()
      const likert = getLikertScale(sequence, totalButtons)
      onclick({...button, textInput : LIKERT_LABELS[!!lang ? lang : 'ES'][likert], extraValueLog : {code : 'likert', value : likert, totalButtons}})
    }
    else onclick(button)
  }
  if (button.tag && button.tag.some(t => t.code === 'checkbox')) {
    return <DbotCheckboxButton button={button} onclick={onclick}/>
  }
  return (
    <Button
      data-cy="all-button" 
      className={`${getCssClass(button.tag)} ${tag} ${appMode}`}
      type="button"
      onClick={onClickF}
      sequence={sequence}
      totalButtons={totalButtons}
      buttonsMiddle={(totalButtons - 1) / 2}
    >
      {getView(button.view, onClickImage, variables)}
    </Button>
  );
};

const getCssClass = (buttonTag) => {
  if (buttonTag === null || buttonTag.length === 0) return "";
  return buttonTag.reduce((res, t) => `${res} ${t.code}`, "");
};
function getView(view, onClickImage, variables) {
  if (view.type === "gif" || view.type === "button-gif") {
    return (
      <GifLoader
        src={view.payload}
        alternative={replaceStringVariables(view.alternativeText, variables)}
        onClickImage={onClickImage}
      />
    );
  } else if (view.type === "link") {
    const split = view.payload.split("@@");
    return (
      <a href={split[0]} target="_blank">
        {split.length > 1 ? split[1] : ""}
      </a>
    );
  } else return replaceStringVariables(view.payload, variables);
}

const getLikertScale = (buttonSequence, totalButtons) => {
  switch (true) {
    case buttonSequence === 0:
      return "strongly_disagree";
    case buttonSequence === 1:
      return "disagree";
    case (buttonSequence === 2 && totalButtons === 5) || (buttonSequence === 3 && totalButtons === 7):
      return "neutral";
    case buttonSequence === 2 && totalButtons === 7:
      return "somewhat_disagree";
    case buttonSequence === 4 && totalButtons === 7:
      return "somewhat_agree";
    case (buttonSequence === 3 && totalButtons === 5) || (buttonSequence === 5 && totalButtons === 7):
      return "agree";
    case buttonSequence === 6 || buttonSequence === 4:
      return "strongly_agree";
    default:
      return "";
  }
}

const LIKERT_LABELS = {
  ES : {
    "strongly_disagree" : "Totalmente en desacuerdo",
    "disagree" : "En desacuerdo",
    "neutral" : "Indiferente",
    "somewhat_disagree" : "Un poco en desacuerdo",
    "somewhat_agree" : "Un poco de acuerdo",
    "agree" : "De acuerdo",
    "strongly_agree" : "Muy de acuerdo"
  },
  EN : {
    "strongly_disagree": "Strongly disagree",
    "disagree": "Disagree",
    "neutral": "Neutral",
    "somewhat_disagree": "Somewhat disagree",
    "somewhat_agree": "Somewhat agree",
    "agree": "Agree",
    "strongly_agree": "Strongly agree"
  }
}